import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InfoStoreModule } from '@wonder-core-ng/info-store/info-store.module';
import { NotificationApiService } from './notification.api.service';
import { NotificationEffects } from './notification.effects';
import * as fromNotification from './notification.reducer';
import { NotificationService } from './notification.service';

/**
 * Registered at the app root, not per route: the header bell reads this on every screen, so the slice
 * has to outlive any single view. Same reason `ConditionStoreModule` is a root registration.
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromNotification.notificationFeatureKey, fromNotification.reducer),
    EffectsModule.forFeature([NotificationEffects]),
    InfoStoreModule,
  ],
  providers: [NotificationApiService, NotificationService],
})
export class NotificationStoreModule {}
